import { MapPin, ChevronRight } from "lucide-react";

const expansion = [
  { label: "New York", status: "active", detail: "Initial focus market" },
  { label: "California", status: "next", detail: "Large market" },
  { label: "Florida", status: "next", detail: "High appeal volume" },
  { label: "Texas", status: "next", detail: "Growing e-filing" },
  { label: "Federal Courts", status: "future", detail: "Nationwide coverage" },
];

export default function MarketSlide() {
  return (
    <div
      className="h-full w-full flex flex-col p-7 sm:p-10 lg:p-12"
      data-testid="slide-market-content"
    >
      <span className="text-sm font-bold tracking-[0.2em] uppercase text-blue-600 mb-2 font-body">
        MARKET OPPORTUNITY
      </span>
      <h1 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-black tracking-tighter text-slate-900 mb-6 leading-tight">
        A high-value, repeat-use legal workflow market
      </h1>

      <div className="flex-1 flex flex-col md:flex-row gap-4 md:gap-8 lg:gap-12 min-h-0">
        <div className="flex-1 flex flex-col justify-center gap-5">
          <div className="bg-blue-50 rounded-xl p-5 border border-blue-100">
            <div className="text-3xl sm:text-4xl font-black text-blue-600 font-heading">
              $5K &ndash; $20K
            </div>
            <div className="text-sm text-slate-600 font-body mt-1">
              Per record on appeal
            </div>
          </div>
          <div className="space-y-3">
            <p className="text-sm text-slate-600 font-body">
              We are starting with New York, which has the busiest courts in the country with thousands of appeals filed annually
            </p>
            <p className="text-sm text-slate-600 font-body">
              Initial focus: law firms in New York
            </p>
            <p className="text-sm text-slate-600 font-body">
              Long term: build the software next for the federal courts and state courts across the country
            </p>
          </div>
        </div>

        <div className="w-full md:w-[300px] shrink-0 flex flex-col justify-center">
          <div className="text-[11px] font-bold tracking-[0.15em] uppercase text-slate-400 mb-4 font-body">
            Expansion Roadmap
          </div>
          {expansion.map((item, i) => (
            <div key={i} className="flex flex-col">
              <div className="flex items-center gap-3">
                <div
                  className={`w-8 h-8 rounded-lg flex items-center justify-center shrink-0 ${
                    item.status === "active"
                      ? "bg-blue-600"
                      : item.status === "next"
                      ? "bg-slate-200"
                      : "bg-slate-100"
                  }`}
                >
                  <MapPin
                    className={`h-3.5 w-3.5 ${
                      item.status === "active" ? "text-white" : "text-slate-400"
                    }`}
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div
                    className={`text-sm font-semibold font-heading ${
                      item.status === "active"
                        ? "text-blue-600"
                        : "text-slate-700"
                    }`}
                  >
                    {item.label}
                  </div>
                  <div className="text-[11px] sm:text-xs text-slate-400 font-body">
                    {item.detail}
                  </div>
                </div>
              </div>
              {i < expansion.length - 1 && (
                <div className="ml-4 w-px h-3 bg-slate-200" />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
